<template>
    <router-link :to="route" :class="{ 'is-active': isActive }" @click="closeMenu"> {{ item.text }}</router-link>
</template>

<script>
import ActiveStatusMixin from '@/mixins/ActiveStatus.mixin.js';

export default {
    name: 'NestedObjective',

    mixins: [ActiveStatusMixin],

    props: {
        closeMenu: {
            type: Function,
            default: () => {},
        },

        item: {
            required: true,
            type: Object,
        },
    },

    computed: {
        route() {
            if (this.$route.name.includes('course-template')) {
                return {
                    name: 'course-template-view-objective',
                    params: {
                        id: this.$route.params.id,
                        objectiveId: this.item.id,
                        item: this.item,
                    },
                };
            }

            return {
                name: 'course-objectives-view',
                params: {
                    courseId: this.$route.params.courseId,
                    objectiveId: this.item.id,
                    item: this.item,
                },
            };
        },
    },
};
</script>
